import { storyblokEditable, type SbBlokData } from "@storyblok/js";
import { allowVisualEditor } from ".";

export const makeEditable = (data: SbBlokData) => {
  return allowVisualEditor() ? storyblokEditable(data) : {};
};
